import {TEffect} from '@packages/systems/plugins/Effect';
import {TJson} from '@packages/systems/plugins/Json';

import {
  forall,
  tyfun,
  error,
  a,
  $,
  func,
} from '@packages/utilities/wfdl-helpers';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins} from '@packages/systems/wfdl';
import {TTypeConstructor, TTypeApplication} from '@packages/systems/wfdl-ast';

export const webhookValue = {
  webhook: {
    envType: {
      dataType: forall(
        ['error', 'a'],
        tyfun(
          [
            TTypeApplication({
              con: TTypeApplication({
                con: TTypeConstructor(
                  qualify(Plugins.name('Logic'), typeName('WebhookParser'))
                ),
                arg: error,
              }),
              arg: a,
            }),
          ],

          tyfun([TJson], TEffect(error, a))
        )
      ),
      exported: 'hidden',
    },
    expression: func(['parser'], $('parser')),
  },
} as const;
